import { render, staticRenderFns } from "./LastOffer.vue?vue&type=template&id=cbaf99bc&"
import script from "./LastOffer.vue?vue&type=script&lang=js&"
export * from "./LastOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports